import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout } from '../modules/auth'
import { App } from '../App'
import { PrivateRoutes } from './PrivateRoutes'
import { Login } from '../modules/auth/Login'
import Authority from '../modules/errors/Authority'

const { BASE_URL } = process.env

const AppRoutes: FC = () => {
  return (
    <BrowserRouter basename={BASE_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='/*' element={<PrivateRoutes />} />
          <Route index element={<Navigate to={'/dashboard'} />} />
          <Route path='login' element={<Login />} />
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='/error/authority' element={<Authority />} />
          <Route path='logout' element={<Logout />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
